import { render, staticRenderFns } from "./Billo.vue?vue&type=template&id=d56e1f0a&"
import script from "./Billo.vue?vue&type=script&lang=js&"
export * from "./Billo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports